export default __webpack_public_path__ + "locales/lv/Settings.json?hash=b429019c4a46f054ebd854d7256bfa76";